<template>
  <div class="box location page">
<section class="section">
<van-sticky class="sticky">

<div style="display:none;">
<studentTitleCard  isChange @change="studentChange">
  <template slot="btn">

  </template>
</studentTitleCard>
</div>
<!-- <div style="height:30px;margin-top:15px;">
      <div class="addStudentClass"  @click="addStudent">
        <van-icon name="add" />   新建考证
      </div>
</div> -->
</van-sticky>

 <div  v-if="faceInfoList.length>0">
    <div class="center" v-for="(item,i) in faceInfoList" :key="i">
      <div  class="ifActiveBox" v-if="!+item.ifActive">
        <img src="@/assets/image/无效.png" width="120px"  alt="">
      </div>
      
        <van-row  gutter="10"  style="border-bottom: 1px solid #dad5d5;padding-bottom:5px;">
        <van-col span="7" @click="showUserDialog = true">
          <van-image v-if="item.sex=='男'" width="96%" :src="require('@/assets/image/男生头像.png')" rel="external nofollow" />
          <van-image v-if="item.sex=='女'" width="96%" :src="require('@/assets/image/女生头像.png')" rel="external nofollow" />

                <!-- <div class="deleteFaceInClass"  v-if="!!+item.ifActive">
                考证作废
               <van-icon name="delete"  @click="deleteFaceIn(item)"/>
                </div> -->
        </van-col>
<van-dialog v-model:show="showUserDialog" width="90%" title="提 示" :show-confirm-button='false' >
  <div style="padding:10px;text-align: left;font-size: 4vw;">
    <p>为保障青少年肖像隐私，</p>
    <p>平台所有证件照片均已进行特征数字转译，</p>
    <p>原图像已彻底删除无法还原。</p>
  </div>
<van-button round  style="width:85%;margin:10px 0;"  color="linear-gradient(to right, #ff6034, #ee0a24)" @click="showUserDialog = false">
  确 定
</van-button>
</van-dialog>
        <van-col span="5"  class="text_l center_title">
            <div>姓 &nbsp;&nbsp; 名</div>
            <!-- <div>性 &nbsp;&nbsp; 别：    </div> -->
            <div>出生日期</div>
            <!-- <div>学 &nbsp;&nbsp; 号</div> -->
            <div>所在学校</div>
            <div>所在班级</div>
        </van-col>
        <van-col span="10" class="text_l center_value">
            <div>{{item.studentName||' '}}</div>
            <!-- <div>{{item.sex||''}}</div> -->
            <div>{{item.birthDay||'--'}}</div>
            <!-- <div>{{item.snCode||' '}}</div> -->
            <div>{{item.schoolName||' '}}</div>
            <div>{{item.studentGradeName}}{{item.className||' '}}</div>
        </van-col>
        </van-row>

        <div class="center_footer">
            <van-row gutter="10">
            <van-col span="18">
                <div class="center_footer_right">
                <div class="center_footer_title"><van-icon name="notes-o"  />有效期</div>
                <!-- <div class="center_footer_right_value">{{ timeFormat(item.createTime?.substring(0,10))}} —  2024年12月31日</div> -->
                <div class="center_footer_right_value">{{ timeFormat(item.createTime?.substring(0,10))}} —  {{timeFormat(item.validUntil)}}</div>
                </div>
            </van-col>
             <van-col span="6">
                <div class="center_footer_left">
                <div @click="onshowQr(item)">
                <vue-qr :text="item.snCode+'&&'+item.schoolCode" :dotScale='0.55'  colorDark="#000" colorLight="#fafafa"  :size="70" :margin='5' ></vue-qr>
            <!-- :logoSrc="require('@/assets/background/loginLog.jpg')" -->
                </div>
            </div>
            </van-col>
            <!-- <van-col span="3">
              <div class="center_footer_delete">
               <van-icon name="delete"  @click="deleteFaceIn(item)"/>
              </div>
            </van-col> -->
            </van-row>
        
            
        </div>
        
    </div>
 </div>   
<van-empty
  v-else
  image-size="80"
  description="暂无信息"
/>
</section>
<footer class="footer van-safe-area-bottom">
    <div class="button-add">
    <CustomButton v-if="childInfoList.length>0" @click="addStudent" text="+  新建考证"/>
    </div>
</footer>

<van-popup v-model:show="showQRDialog" width="80%"   >
  <div >
  <vue-qr style="margin: 0 atuo;" :dotScale='0.8'  colorDark="#000" colorLight="#fff"   :text="showQrData.snCode+'&&'+showQrData.schoolCode"    :margin='8'></vue-qr>
  </div>
</van-popup>


<van-dialog v-model:show="showDialog" width="90%" title="绑定孩子" :show-confirm-button='false' >
    <van-form @submit="onSubmit" style="margin:20px 0">
        <van-field v-model="formData.schoolName"  label="学校" placeholder="请搜索选择学校（如：南京）" :rules="[{ required: true }]" @click="schoolShowPicker = true;" />
        <van-field v-model="formData.snCode" type="text" name="学号" label="学号" placeholder="请输入学号"
          :rules="[{ required: true }]" />
        <van-field v-model="formData.personName" type="text" name="姓名" label="姓名" placeholder="请输入姓名"
          :rules="[{ required: true }]" />

  <div class="buutom">
    <CustomButton  text="返回" @click="showDialog=false" type='2'/>
    <CustomButton  text="确认" native-type="submit" type='1'/>

          <!-- <van-button round block type="default"  class="button-on" @click="showDialog=false">返回</van-button>
          <van-button round block type="info" class="button-on" native-type="submit">确认</van-button> -->
  </div>
      </van-form>

</van-dialog>

   <van-popup v-model="schoolShowPicker" round position="bottom" :style="{ height: '55%' }">
      <van-search v-model="searchvalue" placeholder="请输入学校名称关键字搜索（如：南京）" />
      <van-picker :columns="schoolColumns" :default-index="defaultIndex" show-toolbar @cancel="schoolShowPicker = false"
        @confirm="onConfirmSchool" />
    </van-popup>
    <!-- <van-button round block type="info" class="button-add" @click="addStudent">+  绑定孩子</van-button> -->

    <VDialog ref="VDialog" :objData="objData" @closeDisclose="closeDisclose"/>

  </div>
</template>

<script>
import { Notify } from "vant";
import CustomButton from "@/components/CustomButton.vue";

import { getSchoolList} from "@/api/common";
import { getChildInfoList} from "@/api/studentBind.js";
import { getFaceInfoList,updateFaceStatus} from "@/api/admissionTicket.js";
import studentTitleCard from "@/components/studentTitleCard.vue";
 import { setSession ,getSession} from "@/utils/cookie";
 import VDialog from "@/components/VDialog/studentDisclose.vue";

import vueQr from 'vue-qr'
export default {
  name: "studentBind",
  components: {CustomButton,vueQr,studentTitleCard,VDialog},
  data() {
    return {
      studentInfo:{
        name:'杨森',
        snCode:'6565565656565656',
        schoolName:'南京大学',
        gread:'三年级一班',
        className:'一班'
      },  
      objData: {
        checked: false,
        num: 3,
        showDialog: false,
      },
      formData:{},
      active:'0',
      showDialog:false,
      schoolShowPicker:false,
      searchvalue:'',
      schoolColumns:[],
      columnsAll:[],
      defaultIndex:'',
      faceInfoList:[{
        name:'杨森1',
        sex:'男',
        snCode:'6565565656565212121是大大说21656',
        schoolName:'南京大学',
        gread:'三年级一班',
        time:'2020-22-22',
      },{
        name:'杨森',
        sex:'女',
        snCode:'6565565656565656',
        schoolName:'南京大学',
        gread:'三年级一班',
        time:'2020-22-22',
      }],
      childInfoList:[],
      faceInfoList:[],
      showQRDialog:false,
      showQrData:{},
      childInfoData:{},
      showUserDialog:false
    };
  },
   watch: {
    searchvalue(val) {
      if (!val || !val.trim()) {
        this.schoolColumns = [];
        return;
      }
      this.getSchoolList(val.trim());
    },
  },
  created() {
   
  },
  mounted () {
    this.schoolColumns = [];
    this.getChildInfoList()
  },
  methods: {
    timeFormat(str){

    var reg =/(\d{4})\-(\d{2})\-(\d{2})/;
    if (str) {
    return str.replace(reg,"$1年$2月$3日")||''
    }else{
    return ''

    }
    },
   
    studentChange(val){
      console.log(val);
      this.childInfoData =val
      this.getFaceInfoList()
    },
    deleteFaceIn(item){
        this.$dialog
        .alert({
          title:'提示',
          message: '是否确认将此准考证作废?',
          showCancelButton: true
        })
        .then(() => {
           updateFaceStatus(item).then(res=>{
            this.$notify({ type: "success", message: '操作成功！' });
            this.getFaceInfoList()
           })
        })
        .catch(() => {
          // on cancel
        })
    },
    onshowQr(item){
      console.log(1);
      this.showQrData = item
      this.showQRDialog =true
    },
 
    getFaceInfoList(){
        getFaceInfoList({
            snCode:this.childInfoData.snCode,
            schoolCode:this.childInfoData.schoolCode
        }).then(res=>{
            this.faceInfoList = res.data.data||[]
        })
    },
    getChildInfoList(){
        getChildInfoList({status:'1'}).then(res=>{
        console.log(res);
        res.data.data?.forEach((el,i)=> {
          el.text = el.studentName
          el.value = i
        });
        this.childInfoList = res.data.data||[]
        // if (this.childInfoList.length>0) {
        // this.childInfoData =  JSON.parse(getSession('studentTitleCard'))
        // this.getFaceInfoList()
        // }
        })
    },
    getSchoolList(keyword) {
      if (!keyword || !keyword.trim()) {
        this.schoolColumns = [];
        return;
      }
      getSchoolList({ keyword: keyword.trim() }).then((res) => {
        const body = res?.data?.body || res?.data?.data || res?.data || [];
        if (Array.isArray(body)) {
          this.schoolColumns = body.map((item) => {
            return { text: item.name || item.schName || '', value: item.code || item.schCode || '' };
          }).filter(i => i.text && i.value);
        } else {
          this.schoolColumns = [];
        }
      }).catch(err => {
        console.warn("获取学校失败", err);
        this.schoolColumns = [];
      });
    },
    addStudent(){
    //   this.showDialog = true
    this.objData.showDialog = true;

    },
    closeDisclose(){
      this.$router.push({path:'addFaceIn',query:{studentInfo:JSON.stringify(this.childInfoData)}})
    },
    onSubmit(){
console.log(this.formData);
this.schoolShowPicker = false;
    },
    // 选择学校
       onConfirmSchool(val) {
        this.formData.schoolName = val.text;
        this.formData.schoolId = val.value;
        this.schoolShowPicker = false;
    },
    onRemove(){
        this.$dialog
        .alert({
          message: '是否确认解除绑定?',
          showCancelButton: true
        })
        .then(() => {
           
        })
        .catch(() => {
          // on cancel
        })
    },

  },
};
</script>


<style scoped lang="less">

.box{
  display: flex;
  flex-direction: column;
  font-size: 14px;
  .sticky{
    // background-color: #fff;
    margin-top: 10px;
  }
  .activetabs{
    background-color: #fff;
    
    

  }
  .section{
    flex: 1;
    overflow: scroll;
    .title{
        background-color: #82998b;
        color: #fff;
        height: 90px;
        padding: 20px;

        .title_name{
            font-size: 25px;
            font-weight: normal;
            margin-bottom: 8px;
        }
        .title_footer{
           display: flex;
           justify-content: space-between;
            margin-top: 8px;
        }
    }
    .center{
        // height: 290px;
        padding:15px;
        position: relative;
        background-color: #fff;
        border-radius: 10px;
        // border: 1px solid #ccc;
        margin: 8px;
        margin-bottom: 15px;
        box-shadow: 2px 2px 3px 3px rgba(226, 225, 225, 0.6);

        .ifActiveBox{
          position: absolute;
          right: 10px;
          top: 10px;
          // transform: rotate(45deg);
        }
        .deleteFaceInClass{
          color: #999999;
          margin-top: 50px;
        }
        .center_title{
            color: #999999;
            font-size: 3vw;
            div{
            line-height: 3.7vh;
            }
        }
        .center_value{
            color: #1A1A1A;
            font-size: 3vw;
            font-weight: normal;
            div{
            line-height: 3.7vh;
            }

        }
        .center_footer{
            text-align: left;
            margin-top: 8px;
            .center_footer_title{
                font-size: 3.2vw;
                font-weight: 500;
                margin-top: 17px;
            }
            
            .center_footer_left{

            }
            .center_footer_right{
                .center_footer_right_value{
                font-size: 3.2vw;
                font-weight: 500;
                margin-top: 8px;
                text-align: left;

            }
            }
            .center_footer_delete{
              line-height: 100px;
              font-size: 35px;
              text-align: center;
            }
        }
    }
  }
  .footer{
    display: flex;
    margin-bottom: 6%;
    margin-top: 5%;
    justify-content: space-around;
  }
  }

.addStudentClass{
  background-color: #155CB2;
  border-radius: 16px;
  height: 30px;
  line-height: 30px;
  width: 38%;
  float: right;
  color: #fff;
  text-align: center;
}
  .studentCard{
  background-color: #fff;
  border-radius: 10px;
  margin: 8px;
  padding: 15px;
  border: 1px solid #ccc;
  .studentCard_title{
    display: flex;
    justify-content: space-between;
    font-size: 25px;
    font-weight: 600;
  }
  .studentCard_value{
    font-size: 13px;
    color: #ccc;
  }
}

.text_l{
    text-align: left;
    text-overflow:ellipsis;
    overflow:hidden;
    line-height: 14px;
    // white-space:nowrap;
    
}
.text_c{
    text-align: center;
}
.buutom {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  .button-on{
    width: 48%;
}
}
  .button-add{
    width: 80%;
    margin: 0 auto;
}

</style>
